// eslint-disable-next-line import/prefer-default-export
export const APP_API_FIELDS = [`feedback`, `referral_request`, `visit_request`]
export const ONBOARDING_API_FIELDS = `*`

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

// Note that matching on the API version is a quick solution. We should come up
// with something more robust.
export const FIELDS_TO_SCRUB_BY_API = [
  // Rails app
  {
    regexp: /\/api\/v1\//,
    fields: APP_API_FIELDS,
  },
  // Onboarding API
  {
    regexp: /\/api\/1.0\//,
    fields: ONBOARDING_API_FIELDS,
  },
]
